export const SHOW_COMMENT = 'SHOW_COMMENT'
export const HIDE_COMMENT = 'HIDE_COMMENT'
export const COMMENT_EMPTY = 'COMMENT_EMPTY'

export const GET_COMMENT = 'GET_COMMENT'
export const GET_COMMENT_SUCCESS = 'GET_COMMENT_SUCCESS'
export const GET_COMMENT_FAILURE = 'GET_COMMENT_FAILURE'
export const UPDATE_COMMENT_DART = 'UPDATE_COMMENT_DART'
export const LOADING_COMMENT_DART = 'LOADING_COMMENT_DART'
export const LOADING_COMMENT_DART_ERROR = 'LOADING_COMMENT_DART_ERROR'

export const GET_COMMENTS = 'GET_COMMENTS'
export const GET_COMMENTS_SUCCESS = 'GET_COMMENTS_SUCCESS'
export const GET_COMMENTS_FAILURE = 'GET_COMMENTS_FAILURE'

export const ADD_COMMENT = 'ADD_COMMENT'
export const ADD_COMMENT_SUCCESS = 'ADD_COMMENT_SUCCESS'
export const ADD_COMMENT_FAILURE = 'ADD_COMMENT_FAILURE'

export const DELETE_COMMENT = 'DELETE_COMMENT'
export const DELETE_COMMENT_SUCCESS = 'DELETE_COMMENT_SUCCESS'
export const DELETE_COMMENT_FAILURE = 'DELETE_COMMENT_FAILURE'

export const UPDATE_COMMENT_SUCCESS = 'UPDATE_COMMENT_SUCCESS'

export const SHOW_LIST_COMMENTS = 'SHOW_LIST_COMMENTS'
export const HIDE_LIST_COMMENTS = 'HIDE_LIST_COMMENTS'

export const CONSULT_COMMENT_DETERMINED = 'CONSULT_COMMENT_DETERMINED'
export const SUCCESS_COMMENT_DETERMINED = 'SUCCESS_COMMENT_DETERMINED'

export const SAVE_COMMENT_DETERMINED = 'SAVE_COMMENT_DETERMINED'
export const SAVE_COMMENT_DETERMINED_SUCCESS = 'SAVE_COMMENT_DETERMINED_SUCCESS'
export const SAVE_COMMENT_DETERMINED_FAILURE = 'SAVE_COMMENT_DETERMINED_FAILURE'

export const DELETE_COMMENT_DETERMINED = 'DELETE_COMMENT_DETERMINED '
export const DELETE_COMMENT_DETERMINED_SUCCESS = 'DELETE_COMMENT_DETERMINED_SUCCESS'

export const SHOW_BUTTON_COMMENTS = 'SHOW_BUTTON_COMMENTS'
export const HIDE_BUTTON_COMMENTS = 'HIDE_BUTTON_COMMENTS'

export const SEARCH_COMMENTS = 'SEARCH_COMMENTS'

export const SHOW_COMPARE_VERSIONS = 'SHOW_COMPARE_VERSIONS'
export const HIDE_COMPARE_VERSIONS = 'HIDE_COMPARE_VERSIONS'
export const SET_VERSIONS_COMPARE = 'SET_VERSIONS_COMPARE'
export const SEARCH_COMMENTS_SUCCESS = 'SEARCH_COMMENTS_SUCCESS'
export const SEARCH_COMMENTS_CLEAR = 'SEARCH_COMMENTS_CLEAR'
export const SET_IS_EMPTY_COMPARE_DATA = 'SET_IS_EMPTY_COMPARE_DATA'

export const SHOW_VERSIONS = 'SHOW_VERSIONS'
export const HIDE_VERSIONS = 'HIDE_VERSIONS'

export const DELETE_VERSIONS = 'DELETE_VERSIONS'
export const DELETE_VERSIONS_SUCCESS = 'DELETE_VERSIONS_SUCCESS'

export const SWAP_VERSIONS = 'SWAP_VERSIONS'
export const SWAP_VERSIONS_COMPLETE = 'SWAP_VERSIONS_COMPLETE'
export const SWAP_VERSIONS_ERROR = 'SWAP_VERSIONS_ERROR'

export const SET_QTY_VERSIONS = 'SET_QTY_VERSIONS'

export const SHOW_BUTTON_EMOJI = 'SHOW_BUTTON_EMOJI'
export const HIDE_BUTTON_EMOJI = 'HIDE_BUTTON_EMOJI'

export const SET_SOCKET_COMMENT_SCROLL = 'SET_SOCKET_COMMENT_SCROLL'

export const CLEAR_LAST_COMMENTS = "CLEAR_LAST_COMMENTS"

export const RESET_STATUS_ASSET = "RESET_STATUS_ASSET"

export const CLEAR_FOCUS_DESCRIPTION = "CLEAR_FOCUS_DESCRIPTION"


export const GET_USERS_TO_COMMENT = 'GET_USERS_TO_COMMENT'
export const GET_USERS_TO_COMMENT_SUCCESS = 'GET_USERS_TO_COMMENT_SUCCESS'
export const GET_USERS_TO_COMMENT_FAILURE = 'GET_USERS_TO_COMMENT_FAILURE'
export const CLEAN_USERS_TO_COMMENT = 'CLEAN_USERS_TO_COMMENT'

export const SET_IS_DOING_A_COMMENT_WITH_FILE = "SET_IS_DOING_A_COMMENT_WITH_FILE"
export const UNSET_IS_DOING_A_COMMENT_WITH_FILE = "UNSET_IS_DOING_A_COMMENT_WITH_FILE"


export const SET_PDF_CARROUSEL_INDEX = 'SET_PDF_CARROUSEL_INDEX'
export const GET_PDF_PAGES = 'GET_PDF_PAGES'
export const GET_PDF_PAGES_SUCCESS = 'GET_PDF_PAGES_SUCCESS'
export const GET_PDF_PAGES_FAILURE = 'GET_PDF_PAGES_FAILURE'

export const SET_IS_PDF_TAG_ACTIVE = 'SET_IS_PDF_TAG_ACTIVE'
export const UNSET_IS_PDF_TAG_ACTIVE = 'UNSET_IS_PDF_TAG_ACTIVE'
export const SET_PDF_TAG_CLICKED = 'SET_PDF_TAG_CLICKED'
export const UNSET_PDF_TAG_CLICKED = 'UNSET_PDF_TAG_CLICKED'
export const SET_IMAGE_TAG_CLICKED = 'SET_IMAGE_TAG_CLICKED'
export const UNSET_IMAGE_TAG_CLICKED = 'UNSET_IMAGE_TAG_CLICKED'
export const SET_VIDEO_TAG_CLICKED = 'SET_VIDEO_TAG_CLICKED'
export const UNSET_VIDEO_TAG_CLICKED = 'UNSET_VIDEO_TAG_CLICKED'
export const SET_AUDIO_TAG_CLICKED = 'SET_AUDIO_TAG_CLICKED'
export const UNSET_AUDIO_TAG_CLICKED = 'UNSET_AUDIO_TAG_CLICKED'

export const GET_NEW_COMMENTS = 'GET_NEW_COMMENTS'
export const GET_NEW_COMMENTS_SUCCESS = 'GET_NEW_COMMENTS_SUCCESS'
export const GET_NEW_COMMENTS_FAILURE = 'GET_NEW_COMMENTS_FAILURE'

export const RESTORE_PREVIOUS_PDF_CARROUSEL_INDEX = 'RESTORE_PREVIOUS_PDF_CARROUSEL_INDEX'
export const RESTORE_PREVIOUS_PDF_CARROUSEL_INDEX_SUCCESS = 'RESTORE_PREVIOUS_PDF_CARROUSEL_INDEX_SUCCESS'

export const GET_USER_MENTIONS = 'GET_USER_MENTIONS'
export const GET_USER_MENTIONS_SUCCESS = 'GET_USER_MENTIONS_SUCCESS'
export const GET_USER_MENTIONS_FAILURE = 'GET_USER_MENTIONS_FAILURE'
export const REMOVE_MENTION = 'REMOVE_MENTION'
export const CLEAR_MENTIONS = 'CLEAR_MENTIONS'

export const SET_IS_AUDIO_TAG_ACTIVE = 'SET_IS_AUDIO_TAG_ACTIVE'
export const UNSET_IS_AUDIO_TAG_ACTIVE = 'UNSET_IS_AUDIO_TAG_ACTIVE'

export const SET_IS_VIDEO_TAG_ACTIVE = 'SET_IS_VIDEO_TAG_ACTIVE'
export const UNSET_IS_VIDEO_TAG_ACTIVE = 'UNSET_IS_VIDEO_TAG_ACTIVE'

export const SET_IS_IMAGE_TAG_ACTIVE = 'SET_IS_IMAGE_TAG_ACTIVE'
export const UNSET_IS_IMAGE_TAG_ACTIVE = 'UNSET_IS_IMAGE_TAG_ACTIVE'
